import { SVGProps } from "react";
import { Interpolation, Theme } from "@emotion/react";

export const ContentCardType = ({
  focused,
  ...props
}: SVGProps<SVGSVGElement> & {
  focused?: boolean;
  css?: Interpolation<Theme>;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="path-1-inside-1_1686_20023" fill="white">
        <rect width="8.99892" height="8.99892" rx="0.5" />
      </mask>
      <rect
        width="8.99892"
        height="8.99892"
        rx="0.5"
        fill={focused ? "#333333" : "#CCCCCC"}
        stroke={focused ? "#333333" : "#CCCCCC"}
        strokeWidth="3"
        mask="url(#path-1-inside-1_1686_20023)"
      />
      <mask id="path-2-inside-2_1686_20023" fill="white">
        <rect y="11" width="8.99892" height="8.99892" rx="0.5" />
      </mask>
      <rect
        y="11"
        width="8.99892"
        height="8.99892"
        rx="0.5"
        fill={focused ? "#333333" : "#CCCCCC"}
        stroke={focused ? "#333333" : "#CCCCCC"}
        strokeWidth="3"
        mask="url(#path-2-inside-2_1686_20023)"
      />
      <mask id="path-3-inside-3_1686_20023" fill="white">
        <rect x="11" width="8.99892" height="8.99892" rx="0.5" />
      </mask>
      <rect
        x="11"
        width="8.99892"
        height="8.99892"
        rx="0.5"
        fill={focused ? "#333333" : "#CCCCCC"}
        stroke={focused ? "#333333" : "#CCCCCC"}
        strokeWidth="3"
        mask="url(#path-3-inside-3_1686_20023)"
      />
      <mask id="path-4-inside-4_1686_20023" fill="white">
        <rect x="11" y="11" width="8.99892" height="8.99892" rx="0.5" />
      </mask>
      <rect
        x="11"
        y="11"
        width="8.99892"
        height="8.99892"
        rx="0.5"
        fill={focused ? "#333333" : "#CCCCCC"}
        stroke={focused ? "#333333" : "#CCCCCC"}
        strokeWidth="3"
        mask="url(#path-4-inside-4_1686_20023)"
      />
    </svg>
  );
};
